import {PATH_SERVICE} from './constant';

export const getServicePath = service => `${PATH_SERVICE}/${service}/#detail`;